import { defaultReducers, defaultInitialState, IDefaultState } from "../../../../../redux/_common";
import { createSlice } from "@reduxjs/toolkit";
import { IEditItem, IEntities } from "./_interfaces";

interface IState extends IDefaultState<IEntities, any, IEditItem> {}

const initialState: IState = {
  ...defaultInitialState,
};

const reducers = {
  ...defaultReducers,
};

export const vehiclesSlice = createSlice({
  name: "vehicles",
  initialState,
  reducers,
});
